import { extrairErroEdgeFunction, invokeEdgeFunction } from './edgeFunctionInvoke'

export async function statusGoogleCalendar(usuario_id) {
  if (!usuario_id) return { success: false, conectado: false }
  const { data, error } = await invokeEdgeFunction('google-calendar', {
    action: 'status',
    usuario_id
  })
  if (data?.success) return data
  return {
    success: false,
    conectado: false,
    error: await extrairErroEdgeFunction(error, data)
  }
}

export async function iniciarConexaoGoogleCalendar(usuario_id) {
  const return_url = typeof window !== 'undefined' ? `${window.location.origin}/welcome` : ''
  const { data, error } = await invokeEdgeFunction('google-calendar', {
    action: 'start',
    usuario_id,
    return_url
  })
  if (data?.url) {
    window.location.href = data.url
    return { success: true }
  }
  return {
    success: false,
    error: data?.error || await extrairErroEdgeFunction(error, data) || 'Não foi possível iniciar a conexão com o Google.'
  }
}

export async function desconectarGoogleCalendar(usuario_id) {
  const { data, error } = await invokeEdgeFunction('google-calendar', {
    action: 'disconnect',
    usuario_id
  })
  if (data?.success) return data
  return {
    success: false,
    error: await extrairErroEdgeFunction(error, data)
  }
}

/** Copia o evento para a Google Agenda do responsável e dos associados que conectaram a conta. Não bloqueia o fluxo local. */
export async function sincronizarEventoGoogleCalendar({ usuario_id, evento_id, op = 'upsert' }) {
  if (!evento_id) return { success: false }
  try {
    const { data, error } = await invokeEdgeFunction('google-calendar', {
      action: 'sync',
      usuario_id,
      evento_id,
      op
    })
    if (data?.success) return data
    console.warn('[Google Calendar]', data?.error || error)
    return { success: false, error: data?.error }
  } catch (e) {
    console.warn('[Google Calendar]', e)
    return { success: false, error: e?.message }
  }
}
